export default {
  LOADING: 'MARKETS_VIEW_MARKET_PANEL_LOADING',
  LOADED: 'MARKETS_VIEW_MARKET_PANEL_LOADED',
};
